@if (transaction) {
  <div class="page">
    <div class="receipt-header">
      <img class="icon-md" [src]="'order_confirmed.svg' | themeSource" />
      <span>{{ 'PAYMENT.SUCCESSFUL' | translate }}</span>
      <span>{{ transaction.transaction.created_at | date:'shortTime' }}</span>
      @if (transaction.cheque?.cheque_id) {
        <h6>
          {{ 'PAY_AT_TABLE.CHEQUE' | translate }} #{{ chequeNumber.substr(4) }}
        </h6>
      }
    </div>

    @if (transaction.orders.length && !transaction.cheque?.cheque_id) {
      <app-order-list [orders]="transaction.orders">
      </app-order-list>
    }

    <div class="order-summary">
      @if (transaction.cheque?.cheque_id) {
        <div>
          <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
          <span>{{ (subtotal || 0) | currencySpace }}</span>
        </div>
        @if (transaction.cheque.promo?.amount) {
          <div>
            <span>{{ 'PAY_AT_TABLE.PROMO' | translate }}</span>
            <span>- {{ transaction.cheque.promo.amount | currencySpace }}</span>
          </div>
        }
        @if (+(transaction.cheque.discount_amount ?? 0)) {
          <div>
            <span>{{ 'PAY_AT_TABLE.DISCOUNT' | translate }}</span>
            <span>- {{ (+transaction.cheque.discount_amount || 0) | currencySpace }}</span>
          </div>
        }
        @if (+(transaction.cheque.fee_paid ?? 0)) {
          <div>
            <span>{{ 'PAY_AT_TABLE.FEES' | translate }}</span>
            <span>{{ (+transaction.cheque.fee_paid || 0) | currencySpace }}</span>
          </div>
        }
        @if (+(transaction.cheque.tip_amount ?? 0)) {
          <div class="border-line">
            <span>{{ 'TIP.TIP' | translate }}</span>
            <span>{{ (+(transaction.cheque.tip_amount ?? 0)) | currencySpace }}</span>
          </div>
        }
      }

      @if (transaction.orders[0]?.fee_amount > 0) {
        <div>
          <span>{{ 'COMMON.FEES' | translate }}</span>
          <span>{{ transaction.orders[0].fee_amount | currencySpace }}</span>
        </div>
      }

      @if (total > 0 || +(transaction.cheque?.tip_amount ?? 0) > 0) {
        <div>
          <span>{{ 'PAY_AT_TABLE.AMOUNT_PAID' | translate }}</span>
          <span>{{ total + (+(transaction.cheque?.tip_amount ?? 0)) | currencySpace }}</span>
        </div>
      }
    </div>

    @if (transaction.cheque?.cheque_id && transaction.cheque.payment_mode === 'item_selection' && transaction.cheque.items?.length) {
      <div class="cheque-items">
        <h6>{{ 'PAY_AT_TABLE.PAID_ITEMS' | translate }}</h6>
        @for (item of transaction.cheque.items; track item.item_id) {
          <div class="order-summary">
            <div>
              <span>x{{ item.quantity }} {{ item.name }}</span>
              <span>
                {{ (+item.paid_amount || 0) | currencySpace }}
              </span>
            </div>
          </div>
        }
      </div>
    }

    @if (transaction.orders[0]?.cta?.text) {
      <div class="text-icon-button">
        @if (transaction.orders[0].cta.url) {
          <span (click)="openCTA()">
            {{ transaction.orders[0].cta.text }}
          </span>
          <img class="icon-md" [src]="'link.svg' | themeSource" />
        } @else {
          <span>
            {{ transaction.orders[0].cta.text }}
          </span>
        }
      </div>
    }

    <div class="text-icon-button">
      <span (click)="openReceipt()">
        {{ 'ACTIONS.VIEW_RECEIPT' | translate }}
      </span>
      <img class="icon-lg" [src]="'receipt.svg' | themeSource" (click)="openReceipt()" />
    </div>

    <button class="btn" (click)="close()">
      {{ 'ACTIONS.AWESOME' | translate }}
    </button>
  </div>
}
